import React from 'react';

import { getHighlightedText } from 'helpers/utils';

import { DropdownCountryCurrency, DropdownCountryName, DropdownListItem, DropdownListItemContent } from './styles';
import { FlagIcon } from '../../common/FlagIcon/FlagIcon';
import { PromoText } from '../../no-auth/common/promo-text/PromoText';

const PromoCountryItem = (props) => {
    const country = props.country;
    const prefix = props.prefix;

    const currency = (currencies, query) => {
        return currencies.map((currency) => {
            return (
                <DropdownCountryCurrency key={currency?.id}>
                    {!!query ? (
                        <>
                            {getHighlightedText(query, currency.code, 'promoText', {
                                basicColor: 'gray40',
                                variant: 'subheader',
                                ellipsis: true,
                            })}
                        </>
                    ) : (
                        <PromoText variant="subheader" color="gray40" ellipsis>
                            {currency.code}
                        </PromoText>
                    )}
                </DropdownCountryCurrency>
            );
        });
    };

    return (
        // нужен ли тут id?
        <DropdownListItem
            id={`${prefix}-${country.code}`}
            onClick={(e) => props.onClickHandler(e, country, country.currencies[0])}
            onKeyPress={(e) => props.onClickHandler(e, country, country.currencies[0])}
            tabIndex={'0'}
        >
            <DropdownListItemContent>
                <FlagIcon name={country.code} />
                <DropdownCountryName>
                    {!!props.query ? (
                        <>
                            {getHighlightedText(props.query, country.name, 'promoText', {
                                basicColor: 'gray80',
                                variant: 'subheader',
                            })}
                        </>
                    ) : (
                        <PromoText variant="subheader" color="gray80">
                            {country.name}
                        </PromoText>
                    )}
                </DropdownCountryName>
            </DropdownListItemContent>
            {props.showCurrencies && <>{currency(country.currencies, props.query)}</>}
        </DropdownListItem>
    );
};

export default PromoCountryItem;
